export const STAGE_DEVICE_API_URL =
  'https://uat.support.hp.com/CC-LC/contact?originid=account&cachetoken=TOKEN';
export const PROD_DEVICE_API_URL =
  'https://support.hp.com/CC-LC/contact?originid=account&cachetoken=TOKEN';

export const STAGE_METHONE_CACHE_API_URL =
  'https://api3-itg-methone.hpcloud.hp.com/stg-v4/cache/v3';
export const PROD_METHONE_CACHE_API_URL =
  'https://api3-methone.hpcloud.hp.com/v4/cache/v3';
